import { parseISO } from 'date-fns'

export const parseApiDate = (date: Date | string): Date => {
  if (!date) {
    return new Date()
  }

  if (typeof date !== 'string') {
    return parseISO(date.toString())
  }

  return parseISO(date)
}

export const isValidDate = (date: Date | null): boolean => {
  if (date && Object.prototype.toString.call(date) === '[object Date]') {
    if (Number.isNaN(date.getTime())) {
      return false
    }
    return true
  }

  return false
}
